import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callEdgeFunction } from "@/lib/edge-functions";
import type { UpdateBookingStatusInput } from "@bednbody/types";

/**
 * Status transitions go through PATCH /bookings/:id/status so booking_events
 * is always written (API Conventions). The transition matrix, hub scoping,
 * and the Hub-Manager-cannot-cancel rule are enforced server-side
 * (booking.service.ts); the buttons here are convenience, not the guard.
 * `correctedAt` = the "fix session start times" story (UX Notes §Hub Manager).
 */
export function useTransitionBooking() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: { bookingId: string } & UpdateBookingStatusInput) => {
      const { bookingId, ...body } = input;
      return callEdgeFunction(`bookings/${bookingId}/status`, { method: "PATCH", data: body });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["ops-bookings"] });
      // The detail popup is where every action is taken now — refresh it too.
      queryClient.invalidateQueries({ queryKey: ["booking-detail"] });
      queryClient.invalidateQueries({ queryKey: ["booking-detail-events"] });
      queryClient.invalidateQueries({ queryKey: ["weekly-booking-stats"] });
      queryClient.invalidateQueries({ queryKey: ["cash-remittances"] });
    },
  });
}
